import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export type ContainerProps = {
  secondary?: boolean
}

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.surface.block')};
  `

const shouldForwardProp = (prop: string | number) => {
  return !['secondary'].includes(String(prop))
}

export const Container = styled.main.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  background-color: ${themeGet('colors.surface.screen')};

  ${containerSecondaryCss}
`
